export default {
  'vehiclesHistory.list.header.customer': 'Cliente',
  'vehiclesHistory.list.column.licensePlate': 'Placa',
  'vehiclesHistory.list.column.vehicle': 'Veículo',
  'vehiclesHistory.list.column.fleet': 'Frota',
  'vehiclesHistory.list.header.actions': 'Ações',
  'vehiclesHistory.list.action.button.view': 'Visualizar',

  'vehiclesHistory.details.searchByDescription': 'Pesquisar pela descrição',
  'vehiclesHistory.details.displayAuthorized': 'Exibir Autorizados',

  'vehiclesHistory.details.list.column.description': 'Descrição',
  'vehiclesHistory.details.list.column.quantity': 'Quantidade',
  'vehiclesHistory.details.list.column.unitaryValue': 'Valor Unitário',
  'vehiclesHistory.details.list.column.discount': 'Desconto',
  'vehiclesHistory.details.list.column.totalAmount': 'Valor Total',

  'vehiclesHistory.details.list.info.budget': 'Orçamento',
  'vehiclesHistory.details.list.info.customer': 'Cliente',
  'vehiclesHistory.details.list.info.currentKilometers': 'KM',
};
